<template>
  <div class="form">
    <dx-validation-group ref="validation-group">
      <div class="dx-fieldset">
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("RetailerUser.Company") }}
          </div>
          <DxTextBox class="dx-field-value" :value.sync="company" />
        </div>
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("RetailerUser.FirstName") }}
          </div>
          <DxTextBox class="dx-field-value" :value.sync="firstName">
            <DxValidator key="firstNameValidator">
              <DxRequiredRule
                :message="this.$t('RetailerUser.FirstNameRequired')"
              />
            </DxValidator>
          </DxTextBox>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("RetailerUser.LastName") }}
          </div>
          <DxTextBox class="dx-field-value" :value.sync="lastName">
            <DxValidator>
              <DxRequiredRule
                :message="this.$t('RetailerUser.LastNameRequired')"
              />
            </DxValidator>
          </DxTextBox>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("RetailerUser.Email") }}
          </div>
          <DxTextBox class="dx-field-value" :value.sync="email">
            <DxValidator>
              <DxRequiredRule
                :message="this.$t('RetailerUser.EmailRequired')"
              />
              <DxEmailRule
                :message="this.$t('RetailerUser.EmailInvalid')"
              />
            </DxValidator>
          </DxTextBox>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("RetailerUser.PhoneNumber") }}
          </div>
          <DxTextBox class="dx-field-value" :value.sync="phoneNumber" />
        </div>
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("RetailerUser.Role") }}
          </div>
          <div class="dx-field-value">
            <DxSelectBox
              :items="roles"
              :value.sync="idRole"
              display-expr="description"
              value-expr="id"
            />
          </div>
        </div>
        <div class="dx-field">
          <div class="dx-field-label">
            {{ this.$t("RetailerUser.Language") }}
          </div>
          <div class="dx-field-value">
            <DxSelectBox
              :items="languages"
              :value.sync="language"
              display-expr="description"
              value-expr="code"
            />
          </div>
        </div>
      </div>
      <vs-button
        @click="inviteUser"
        class="float-right px-4 w-full md:w-auto mt-6"
        >{{ this.$t("RetailerUser.SendInvitation") }}</vs-button
      >
    </dx-validation-group>
  </div>
</template>


<script>
import DxTextBox from 'devextreme-vue/text-box'
import DxTextArea from 'devextreme-vue/text-area'
import DxSelectBox from 'devextreme-vue/select-box'
import DxButton from 'devextreme-vue/button'
import DxValidationGroup from 'devextreme-vue/validation-group'
import DxValidationSummary from 'devextreme-vue/validation-summary'
import {
  DxValidator,
  DxRequiredRule,
  DxCompareRule,
  DxEmailRule,
  DxPatternRule,
  DxStringLengthRule,
  DxRangeRule,
  DxAsyncRule
} from 'devextreme-vue/validator'
import {notifyMixin} from '@/mixins/notifyMixin'

export default {
  mixins : [notifyMixin],
  data () {
    return {
      company: '',
      email: '',
      phoneNumber: '',
      firstName: '',
      lastName: '',
      language: 'nl',
      idRole: 3
    }
  },
  components: {
    DxTextBox,
    DxTextArea,
    DxButton,
    DxSelectBox,
    DxValidator,
    DxRequiredRule,
    DxCompareRule,
    DxEmailRule,
    DxPatternRule,
    DxStringLengthRule,
    DxRangeRule,
    DxAsyncRule,
    DxValidationSummary,
    DxValidationGroup
  },
  props: {
    showPopup: Boolean,
    idOrganisation: Number,
    idRetailer: Number
  },
  methods: {
    inviteUser () {
      const validationGroup = this.$refs["validation-group"].instance
      const result = validationGroup.validate()
      if (result.isValid) {
        this.$vs.loading()
        const payload = {
          idOrganisation: this.idOrganisation,
          idRetailer: this.idRetailer,
          company: this.company,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phoneNumber: this.phoneNumber,
          idRole: this.idRole,
          language: this.language
        }
        this.$store
          .dispatch(
            'retailerManagement/inviteRetailerUser',
            payload
          )
          .then(() => {
            this.$vs.loading.close()
            this.$emit('update:showPopup', false)
          })
          .catch((error) => {
            const errorMessage = this.$t(`RetailerUser.${error.response.statusText}`)        
            this.notifyError(errorMessage)
            this.$vs.loading.close()
          })

      }
    }
  },
  computed: {
    roles () {
      return this.$store.state.refCodes.roles.map(a => {
        return { ...a, description: this.$t(`RoleList.${a.description}`) }
      })
    },
    languages () {
      return this.$store.state.refCodes.languages.map(a => {
        return { ...a, description: this.$t(`LanguageList.${a.description}`) }
      })
    },
  }
}
</script>
